import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware, { END } from 'redux-saga';
import { connectRouter, routerMiddleware } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import { auth } from './reducers/authReducer';
import { widget } from './reducers/widgetReducer';
import { collection } from './reducers/collectionReducer';
import { device } from './reducers/deviceReducers';
import { group } from './reducers/groupReducers';
import { admin } from './reducers/adminReducers';
interface ExtendedStore {
  runSaga: (saga) => void;
  close: () => void;
}

export const history = createBrowserHistory();

const sagaMiddleware = createSagaMiddleware();

const rootReducer = {
  router: connectRouter(history),
  auth: auth,
  widget: widget,
  collection: collection,
  device: device,
  group: group,
  admin: admin,
};

const store = configureStore({
  reducer: rootReducer,
  //@ts-expect-error: redux error
  middleware: (getDefaultMiddleware) => [
    ...getDefaultMiddleware(),
    sagaMiddleware,
    routerMiddleware(history),
  ],
  devTools: process.env.NODE_ENV !== 'production',
});

const customStoreFunctions: ExtendedStore = {
  runSaga: sagaMiddleware.run,
  close: () => store.dispatch(END),
};

export { store, customStoreFunctions };
